import Button from '@mui/material/Button';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

const BlogPageFilters = (props) => {
    const { tags } = props;
    const tagData = tags;
    const router = useRouter();
    const query = _.get(router, 'query');

    const onFilterClick = (slug) => {

        const newQuery = { ...query };

        newQuery.filter = slug;

        // if (newQuery.page) {
        //     newQuery.page = 1;
        // }

        router.push({ pathname: '/blog', query: { filter: slug } }, undefined, { shallow: false });
    };

    const renderAllFilterButtons = () => {
        return _.map(tagData, (tag, index) => {
            const tagName = _.get(tag, 'name');
            const tagSlug = _.get(tag, 'id');

            return (
                <Button className='blog-page-filter-pill-button' key={index} {...props} onClick={() => onFilterClick(tagSlug)}>
                    {tagName}
                </Button>
            );
        });
    };

    return (

        <div id="blog-page-filters" className='container-root blog-page-filters-container'>

            <Button className='blog-page-filter-pill-button' {...props} onClick={() => onFilterClick('all')}>

                All

            </Button>

            {renderAllFilterButtons()}

        </div>

    );
};

export default BlogPageFilters;

BlogPageFilters.propTypes = {
    tags: PropTypes.array,
};

